import React, { FC, ReactNode } from "react";
import { Badge } from "antd";

// The one unread-count badge for every chat - recruiter, hiring manager and
// candidate dashboards all use it, so a count always looks the same: a red circle
// with the number inside. It used to be restyled per screen (the hiring manager's
// was green), and one had no styling at all.
export const ChatBadge: FC<{
  count: number;
  children?: ReactNode;
  offset?: [number, number];
}> = ({ count, children, offset = [-6, 6] }) => (
  <Badge
    count={count}
    showZero={false}
    overflowCount={99}
    offset={children ? offset : undefined}
    style={{
      backgroundColor: "#ff4d4f",
      color: "#fff",
      fontWeight: 700,
      fontSize: 12,
      minWidth: 20,
      height: 20,
      lineHeight: "20px",
      borderRadius: 10,
      boxShadow: "0 0 0 2px #fff",
    }}
  >
    {children}
  </Badge>
);
